import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const LikeIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.2616 1.25456L5.64495 5.87123C5.33662 6.17956 5.16162 6.60456 5.16162 7.04623V15.3712C5.16162 16.2879 5.91162 17.0379 6.82829 17.0379H14.3283C14.995 17.0379 15.595 16.6379 15.8616 16.0296L18.5783 9.6879C19.2783 8.0379 18.07 6.20456 16.2783 6.20456H11.57L12.3616 2.3879C12.445 1.97123 12.32 1.54623 12.02 1.24623C11.5283 0.762897 10.745 0.762897 10.2616 1.25456ZM1.82829 17.0379C2.74495 17.0379 3.49495 16.2879 3.49495 15.3712V8.70456C3.49495 7.7879 2.74495 7.0379 1.82829 7.0379C0.911621 7.0379 0.161621 7.7879 0.161621 8.70456V15.3712C0.161621 16.2879 0.911621 17.0379 1.82829 17.0379Z"/>
    </StyledSVGIcon>
  );
};